<script>
export default {
  props: {
    inbox: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    hasAgentBot: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['openCreatePopup'],
  methods: {
    openCreatePopup() {
      this.$emit('openCreatePopup', this.inbox);
    },
  },
};
</script>

<template>
  <tr class="inbox-row">
    <td class="text-left">
      {{ index + 1 }}
    </td>
    <td class="text-left">
      <div class="flex items-center">
        <span class="inbox-name">{{ inbox.name }}</span>
      </div>
    </td>
    <td class="text-center">
      <div class="flex items-center justify-center">
        <!-- Agent Bot Status Badge -->
        <span
          v-if="hasAgentBot"
          class="ml-2 px-2 py-0.5 text-xs font-medium rounded-full bg-green-100 text-green-800"
        >
          {{
            $t('INTEGRATION_SETTINGS.AGENT_BOTS.INBOX_LABELS.AGENT_BOT_ENABLED')
          }}
        </span>
        <span
          v-else
          class="ml-2 px-2 py-0.5 text-xs font-medium rounded-full bg-slate-100 text-slate-600"
        >
          {{ $t('INTEGRATION_SETTINGS.AGENT_BOTS.INBOX_LABELS.NO_AGENT_BOT') }}
        </span>
      </div>
    </td>
    <td class="text-right">
      <div class="flex justify-end">
        <woot-button
          :variant="hasAgentBot ? 'clear' : 'filled'"
          :color-scheme="hasAgentBot ? 'secondary' : 'primary'"
          :icon="hasAgentBot ? 'settings' : 'add-circle'"
          @click="openCreatePopup"
        >
          {{
            hasAgentBot
              ? $t('INTEGRATION_SETTINGS.AGENT_BOTS.ACTIONS.CONFIGURE')
              : $t('INTEGRATION_SETTINGS.AGENT_BOTS.ACTIONS.CONFIGURE')
          }}
        </woot-button>
      </div>
    </td>
  </tr>
</template>

<style scoped>
.inbox-name {
  font-weight: 500;
}
</style>
